import { Button, Center, Flex, Switch, TextInput, Select } from "@mantine/core";
import { modals } from "@mantine/modals";

import { useCallback, useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import DeviceForm from "./DeviceForm";
import DeviceTable from "./DeviceTable";

import { groupListState } from "components/Form/atom/groupListState";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { getPathname } from "utils/getPathname";
import { deleteDevice, getControllerIdList, getDevice, updateDeviceInfo } from "../apis/adminDeviceApis";

function DeviceEditForm() {
  // eslint-disable-next-line no-unused-vars
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [controlList, setControlList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [controlSelectedRecords, setControlSelectedRecords] = useState([]);
  const [statusSelectedRecords, setStatusSelectedRecords] = useState([]);
  const [defaultValues, setDefaultValues] = useState({});
  const [controllerIdList, setControllerIdList] = useState([]); 
  const [,updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  const bsdId = getPathname();
  const navigate = useNavigate();

  const location = useLocation();   //add bjkim6114
  let backPage = 1;
  let backGroup;
  if (location.state) {
    backPage = location.state.pg;
    backGroup = location.state.group;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    if (backGroup !== undefined && backGroup !== null) {
      params.set("group", backGroup);
    }
    navigate(`/admin/device?${params.toString()}`, {replace: true});
  };

  useEffect(() => {
    getControllerIdList(null).then((res) => {
      setControllerIdList(res);
    });
  }, []);

  useEffect(() => {
    getDevice(bsdId).then((res) => {
      setDefaultValues(res.device);
      setControlList(res.ctrl);
      setStatusList(res.sttus);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const filterAndSetRecords = (list, setRecords) => {
      const filteredList = list?.filter((record) => record?.chnnl_prcsdg === "1");
      setRecords(filteredList ?? []);
    };

    filterAndSetRecords(controlList, setControlSelectedRecords);
    filterAndSetRecords(statusList, setStatusSelectedRecords);
  }, [controlList, statusList]);

  const updateSelectRecords = () => {
    // 1. selectedControlState에 담긴 애들의 chnnl_prcsdg를 전부 "1"로 만듭니다.
    const newControlSelectedRecords = controlSelectedRecords.map((record) => ({
      ...record,
      chnnl_prcsdg: "1",
    }));

    // 2. controlState에 담긴 애들 중, selectedControlState에 담긴 애들을 제외한 나머지 애들의 chnnl_prcsdg를 전부 "0"으로 만듭니다.
    const selectedIds = newControlSelectedRecords.map((record) => record.bsd_ctrl_id);

    const newControlList = controlList.map((record) => {
      if (selectedIds.includes(record.bsd_ctrl_id)) {
        return {
          ...record,
          chnnl_prcsdg: "1",
        };
      } else {
        return {
          ...record,
          chnnl_prcsdg: "0",
        };
      }
    });

    // 3. statusSelectedRecords의 chnnl_prcsdg를 전부 "1"로 만듭니다.
    const newStatusSelectedRecords = statusSelectedRecords.map((record) => ({
      ...record,
      chnnl_prcsdg: "1",
    }));

    // 4. statusList 중, statusSelectedRecords에 담긴 애들을 제외한 나머지 애들의 chnnl_prcsdg를 전부 "0"으로 만듭니다.
    const selectedStatusIds = newStatusSelectedRecords.map((record) => record.bsd_sttus_id);

    const newStatusList = statusList.map((record) => {
      if (selectedStatusIds.includes(record.bsd_sttus_id)) {
        return {
          ...record,
          chnnl_prcsdg: "1",
        };
      } else {
        return {
          ...record,
          chnnl_prcsdg: "0",
        };
      }
    });

    return { newControlList, newStatusList };
  };


  const SetHistorical = (e,record) => {
    let historicalData = statusList?.find(item => item.chnnl_no === record.chnnl_no);
    historicalData.alar_at = e.currentTarget.checked ? 'Y' : 'N';
    forceUpdate();
  }

  const getSttusChnnlName = (e,record) => {
    let sttusChnnl = statusList?.find(item => item.chnnl_no === record.chnnl_no);
    sttusChnnl.chnnl_nm = e.target.value;
    forceUpdate();
  }

  const getCtrlChnnlName = (e,record) => {
    let ctrlChnnl = controlList?.find(item => item.chnnl_no === record.chnnl_no);
    ctrlChnnl.chnnl_nm = e.target.value;
    forceUpdate();
  }

  const statusOptions = (currentRecord) => {
    const selectedFeedbacks = controlList
      .filter(item => item.bsd_ctrl_id !== currentRecord.bsd_ctrl_id)
      .map(item => item.feedback_ch)
      .filter(Boolean);

    return [
      {
        value: "",
        label: "",
      },
      ...statusList.map(item => ({
        value: item.bsd_sttus_id,
        label: `${item.chnnl_no} - ${item.chnnl_nm}`,
        disabled: selectedFeedbacks.includes(item.bsd_sttus_id),
      })),
    ];
  };

  const fields = [
    {
      key: "cntlr_id",
      name: "컨트롤러 아이디",
      type: "text",
    },
    {
      key: "bsd_nm",
      name: "장치명",
      type: "text",
    },
    {
      key: "group_id",
      name: "그룹선택",
      type: "select",
      options: groupList,
    },
    {
      key: "device_ip",
      name: "장치 IP",
      type: "text",
    },
    {
      key: "map_xcord",
      name: "경도",
      type: "text",
    },
    {
      key: "map_ycord",
      name: "위도",
      type: "text",
    },
    {
      key: "location",
      name: "지도",
      type: "map_picker",
      fullWidth: true,
    },
    {
      key: "model_nm",
      name: "모델명",
      type: "text",
    },
    {
      key: "makr_nm",
      name: "제조사",
      type: "text",
    },
    {
      key: "protocol",
      name: "프로토콜",
      type: "select",
      options: ["V 1.02"],
      defaultValue: "V 1.02",
    },
    {
      key: "instl_lc",
      name: "주소",
      type: "text",
      fullWidth: true,
      validate: (value) => {
        if (typeof value === "undefined" || !value) {
          return "주소를 입력해주세요.";
        }
        if (value.length < 6) {
          return "주소는 최소 6자 이상 입력해주세요.";
        }
      },
    },
    {
      key: "rm",
      name: "비고",
      type: "text",
      fullWidth: true,
    },
  ];

  const controlColumns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => controlList.indexOf(record) + 1,
      sortable: false,
    },
    {
      accessor: "chnnl_nm",
      title: "채널명",
      sortable: null,
      textAlignment: "center",
      render : (record) => (
        <TextInput
          placeholder="채널 명"
          value={record.chnnl_nm ?? ""}
          onChange={(e) => getCtrlChnnlName(e,record)}
        />
      ),
    },
    {
      accessor: "chnnl_no",
      title: "채널번호",
      sortable: null,
      textAlignment: "center",
    },
    {
      accessor: "feedback_ch",
      title: "피드백 채널",
      sortable: null,
      textAlignment: "center",
      render: (record) => (
        <Select
          placeholder="피드백 채널 선택"
          value={record.feedback_ch ?? ""}
          data={statusOptions(record)}
          onChange={(value) =>
            setControlList((prev) =>
              prev.map((item) =>
                item.bsd_ctrl_id === record.bsd_ctrl_id
                  ? { ...item, feedback_ch: value }
                  : item
              )
            )
          }
        />
      ),
    }
  ];

  const statusColumns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => statusList.indexOf(record) + 1,
      sortable: false,
    },
    {
      accessor: "chnnl_nm",
      title: "채널명",
      sortable: null,
      textAlignment: "center",
      render : (record) => (
        <TextInput
          placeholder="채널 명"
          value={record.chnnl_nm ?? ""}
          onChange={(e) => getSttusChnnlName(e,record)}
        />
      ),
    },
    {
      accessor: "chnnl_no",
      title: "채널번호",
      sortable: null,
      textAlignment: "center",
    },
    {
      accessor: "alar_at",
      title: "상태이력 저장",
      sortable: null,
      textAlignment: "center",
      render : (record) => (
        <Switch onLabel="Yes" offLabel="No"
          size="md"
          label={record.alar_at}
          checked={record.alar_at === 'Y' ? true : false}
          onChange={(e) => SetHistorical(e,record)}
        />
      ),
    },
  ];

  const onSubmit = (e) => {
    console.log(e);
    updateSelectRecords();
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "수정", cancel: "취소" },
      onConfirm: () => {
        const isExistedId = controllerIdList.find(v => v.cntlr_id === e.cntlr_id);
        if ( !isExistedId || (isExistedId && (e.bsd_id === isExistedId.bsd_id)) ){
          const { newControlList, newStatusList } = updateSelectRecords();
          // 네이버 지도 좌표를 클릭하여 경도/위도 변경 후 저장시 숫자형으로 데이터가 전달되어 DB 저장이 되지 않아 문자로 변경하여 전달
          const payload = {
            ...e,
            map_xcord: e.map_xcord?.toString() ?? "",
            map_ycord: e.map_ycord?.toString() ?? "",
          };
          updateDeviceInfo(payload, bsdId, newControlList, newStatusList, e.instl_lc);
          backToList();
        }
        else {
          alert("이미 존재하는 장치입니다 ");
        }
      },
    });
  };

  const onDelete = () => {
    modals.openConfirmModal({
      title: "삭제",
   //   centered: true,
      zIndex: 2000,
      children: <Center>정말 삭제하시겠습니까? (삭제 후 복구불가)</Center>,
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteDevice(bsdId);
        backToList();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Flex
          style={{
            width: "100%",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button color="red" onClick={() => onDelete()}>
            삭제
          </Button>
          <Button type="submit">수정</Button>
        </Flex>
      </Center>
    );
  };

  return (
    <>
      <Styled.Grid>
        <DeviceForm
          fields={fields}
          onSubmit={onSubmit}
          submitButton={<SubmitButton />}
          defaultValues={defaultValues}
        />
        <div> [ 제어 채널 ]
          <DeviceTable
            searchBar
            data={controlList}
            columns={controlColumns}
            selectedRecords={controlSelectedRecords}
            setSelectedRecords={setControlSelectedRecords}
            idAccessor="chnnl_no"
          />
        </div>
        <div> [ 상태 채널 ]
          <DeviceTable
            searchBar
            data={statusList}
            columns={statusColumns}
            selectedRecords={statusSelectedRecords}
            setSelectedRecords={setStatusSelectedRecords}
            idAccessor="chnnl_no"
          />
        </div>
      </Styled.Grid>
    </>
  );
}

export default DeviceEditForm;

const Styled = {
  Grid: styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto 1fr;
    grid-gap: 10px;

    & > div:nth-of-type(1) {
      grid-column: 1 / span 2;
    }
  `,
};
